import mailFolderService from '../../../services/mailFolder.service'

export default {
  async getListMailFolder({ dispatch, commit }, data) {
    return await mailFolderService.getListMailFolder(data)
      .then(response => {
        if (response.success && response.data) {
          const listMailFolder = response.data
          commit("SET_LIST_MAIL_FOLDER", listMailFolder)
          return Promise.resolve(response.data);
        } else {
          commit("SET_LIST_MAIL_FOLDER", [])
          dispatch("alertError", response.message, { root: true });
          return Promise.reject(response.message);
        }
      }).catch(error => {
        commit("SET_LIST_MAIL_FOLDER", [])
        return Promise.reject(false);
      })
  },
  async createMailFolder({ dispatch, commit }, data) {
    return await mailFolderService.createMailFolder(data)
      .then(response => {
        if (response.success) {
          if (response.data == true) {
            dispatch("alertSuccess", response.message[0], { root: true });
          }
          else {
            dispatch("alertError", response.message[0], { root: true });
          }
          return Promise.resolve(response.data);
        } else {
          dispatch("alertError", response.message, { root: true });
          return Promise.reject(response.message);
        }
      }).catch(error => {
        dispatch("alertError", error.message, { root: true });
        return Promise.reject(false);
      })
  },
  async updateMailFolder({ dispatch, commit }, data) {
    return await mailFolderService.updateMailFolder(data)
      .then(response => {
        if (response.success) {
          if (response.data == true) {
            dispatch("alertSuccess", response.message[0], { root: true });
          }
          else {
            dispatch("alertError", response.message[0], { root: true });
          }
          return Promise.resolve(response.data);
        } else {
          dispatch("alertError", response.message, { root: true });
          return Promise.reject(response.message);
        }
      }).catch(error => {
        dispatch("alertError", error.message, { root: true });
        return Promise.reject(false);
      })
  },
  async deleteMailFolder({ dispatch, commit }, data) {
    return await mailFolderService.deleteMailFolder(data)
      .then(response => {
        if (response.success) {
          dispatch("alertSuccess", response.message[0], { root: true });
          return Promise.resolve(response.data);
        } else {
          dispatch("alertError", response.message[0], { root: true });
          return Promise.reject(response.message);
        }
      }).catch(error => {
        dispatch("alertError", error.message, { root: true });
        return Promise.reject(false);
      })
  },
  async moveToFolder({ dispatch, commit }, data) {
    return await mailFolderService.moveToFolder(data)
      .then(response => {
        if (response.success) {
          dispatch("alertSuccess", response.message[0], { root: true });
          return Promise.resolve(response.data);
        } else {
          dispatch("alertError", response.message[0], { root: true });
          return Promise.reject(response.message);
        }
      }).catch(error => {
        dispatch("alertError", error.message, { root: true });
        return Promise.reject(false);
      })
  },
}